import React, {useState, useEffect} from 'react';
import { Link, useLocation} from 'react-router-dom'
import scrollToTop from './scrollToTop'

export default function Topbar(props) {
    const [navOpen, setNavOpen] = useState(false);
    let location = useLocation();
    let newPath = location.pathname.replace('/cp/', '');
    const [oldPath, setOldPath] = useState(newPath);

    let width = window.innerWidth;
    
    let toggleNav = () => {
        setNavOpen(!navOpen);
    }

    useEffect(() => {
        setNavOpen(false);
    }, [newPath])

    let styleCurrentLink = () => {
        let styleComponent = (id, styles) => {
            document.getElementById(id).style.backgroundColor = styles[0];
            let children = document.getElementById(id).childNodes;
            for(let i = 0; i < children.length; i++) {
                children[i].style.color = styles[1];
                children[i].style.fontWeight = styles[2];
            }
        }
        
        if(oldPath && document.getElementById(oldPath)) {
            styleComponent(oldPath, ['', '', '']);
        }
        if(document.getElementById(newPath)) {
            styleComponent(newPath, ['#232429', '#fff', '900']);
            setOldPath(newPath);
        }
    } 

    useEffect(() => {
        styleCurrentLink();
    }, [oldPath, props.colors, newPath])
    
    scrollToTop();
    return (
        <header className="navbar" style={{backgroundColor: props.colors.background}}>
            <div className="header-container">
                <a href={props.navData.churchWebsite} className="brand-logo">
                    <div className="center logo-container">
                        <img src={props.navData.logo} alt=""/>
                    </div>
                </a>

                { width > 700 ?
                    <div className="return-home" 
                        style={{
                            width: '100%',
                            display: 'flex'
                        }}>
                        <Link to={`${props.urlParams}/cp`}>
                            <button
                                style={{
                                    padding: '10px',
                                }}>
                                <h4><i class="las la-angle-left"></i>Return Home</h4>
                            </button>
                        </Link>
                    </div> :

                    <Link to={`${props.urlParams}/cp`}>
                        <button
                            style={{
                                margin: '10px 0',
                                padding: '10px',
                                position: 'relative',
                                left: '-260px'
                            }}>
                            <h4><i class="las la-angle-left"></i>Return Home</h4>
                        </button>
                    </Link>
                }
            </div>
            <div className="center church-name" style={{backgroundColor: props.colors.secondary}}>
            <h4 style={{
                    fontWeight: '900',
                    marginLeft: '10px',
                    color: 'white'
                }}>{props.navData.orgFullName}</h4>
                <div className="center dedicated_number">
                    <h4>{props.orgMessagingNumberLabel}</h4>
                    <h4>{props.orgMessagingNumberValue}</h4>
                </div>
            </div>
        </header>
    )
}
